import React from "react";
import cn from "classnames";

class Genres extends React.Component {
  render() {
    const { className } = this.props;

    return (
      <React.Fragment>
        {this.props.genres &&
          this.props.genres.length > 0 && (
            <div
              className={cn(
                "shadow rounded self-center border-b-2 py-2 mb-4",
                className
              )}
            >
              <div className="p-2 text-xl text-center cursor-default">
                Genre{this.props.genres.length > 1 && "s"}
              </div>

              <ul className="flex flex-wrap list-reset mt-3">
                {this.props.genres.map(genre => {
                  return (
                    <li className="pl-3 mb-4 leading-tight" key={genre.id}>
                      <a
                        className="rounded text-sm no-underline text-blue text-center bg-blue-lightest py-1 px-4"
                        href={`/genre/${genre.id}/${genre.name}`}
                      >
                        {genre.name}
                      </a>
                    </li>
                  );
                })}
              </ul>
            </div>
          )}
      </React.Fragment>
    );
  }
}

export default Genres;



// WEBPACK FOOTER //
// ./src/components/Media/Genres.js